import Button from '@doordash/component-button'
import Toggle from '@doordash/component-toggle'

import {
  Breakpoints,
  Colors,
  Stack,
  StackChildren,
  Text,
} from '@doordash/design-language'
import * as React from 'react'
import MediaQuery from 'react-responsive'
import { LandingPage as Tag } from '../../../../../models/selectorAnchors'
import t from './strings'
import {
  InputContainer,
  InputField,
  SlideFormContainer,
  BtnStyledText,
} from './styles'

type SlideProps = {
  title?: string[]
  subtitle?: string
  legalText?: JSX.Element
  buttonProps?: typeof Button
  buttonSizeProps?: typeof Button
  toggleProps?: typeof Toggle
  toggleError?: string
  secondaryAction: () => void
  legalTextCheckbox?: boolean
}

export class Slide extends React.Component<SlideProps> {
  public render() {
    const {
      title,
      subtitle,
      legalText,
      buttonProps,
      buttonSizeProps,
      toggleProps,
      children,
      secondaryAction,
      legalTextCheckbox,
    } = this.props
    const defaultTitle = [t.title1of3(), t.title2of3(), t.title3of3()]
    const defaultSubtitle = t.subtitle()

    const slideTitle = title || defaultTitle
    const slideSubtitle = subtitle || defaultSubtitle

    // the * 2 is a hack until we get a DLS compliant design
    return (
      <React.Fragment>
        <MediaQuery maxWidth={Breakpoints.Mobile}>
          <Stack>
            <Text
              styles={Text.Styles.Bold32}
              textAlign={Text.TextAlignments.Center}
            >
              {slideTitle.join(' ')}
            </Text>
          </Stack>
        </MediaQuery>
        <MediaQuery minWidth={Breakpoints.Mobile}>
          <StackChildren size={StackChildren.Sizes.None}>
            {slideTitle.map(slideTitleText => (
              <Text
                key={slideTitleText}
                display={Text.DisplayModes.Block}
                size={Text.Sizes.S40 * 2}
                styles={Text.Styles.MajorPageTitle}
                lineHeight={Text.LineHeights.S40}
              >
                {slideTitleText}
              </Text>
            ))}
          </StackChildren>
          <Text styles={Text.Styles.Medium18} color={Colors.SystemGrey60}>
            {slideSubtitle}
          </Text>
        </MediaQuery>
        <SlideFormContainer>
          <MediaQuery maxWidth={Breakpoints.Mobile}>
            <Stack>
              <Text
                styles={Text.Styles.Bold16}
                textAlign={Text.TextAlignments.Center}
              >
                {slideSubtitle}
              </Text>
            </Stack>
          </MediaQuery>
          <Stack>
            <InputContainer>
              <InputField>{children}</InputField>
              <MediaQuery maxWidth={Breakpoints.Mobile}>
                <Stack>
                  {legalTextCheckbox && toggleProps ? (
                    <Toggle
                      {...toggleProps}
                      label={legalText}
                      error={this.props.toggleError}
                    />
                  ) : (
                    <Text
                      styles={Text.Styles.Medium12}
                      color={Colors.SystemGrey100}
                      lineHeight={Text.LineHeights.S16}
                    >
                      {legalText}
                    </Text>
                  )}
                </Stack>
              </MediaQuery>
              {buttonProps && (
                <React.Fragment>
                  <MediaQuery maxWidth={Breakpoints.Mobile}>
                    <Button
                      {...buttonProps}
                      type={Button.Types.PrimaryPill}
                      data-anchor-id={Tag.PrimaryAction}
                    >
                      {buttonProps.text || t.getStarted()}
                    </Button>
                  </MediaQuery>
                  <MediaQuery minWidth={Breakpoints.Mobile}>
                    <Button
                      {...buttonProps}
                      isInline
                      padding={Button.Padding.Wide}
                      type={Button.Types.PrimaryPill}
                      data-anchor-id={Tag.PrimaryAction}
                      {...buttonSizeProps}
                    >
                      {buttonProps.text || t.getStarted()}
                    </Button>
                  </MediaQuery>
                </React.Fragment>
              )}
            </InputContainer>
          </Stack>
          <MediaQuery minWidth={Breakpoints.Mobile}>
            {legalTextCheckbox && toggleProps ? (
              <Toggle
                {...toggleProps}
                label={legalText}
                error={this.props.toggleError}
              />
            ) : (
              <Text
                styles={Text.Styles.Medium12}
                color={Colors.SystemGrey80}
                lineHeight={Text.LineHeights.S16}
              >
                {legalText}
              </Text>
            )}
          </MediaQuery>
          <MediaQuery maxWidth={Breakpoints.Mobile}>
            <BtnStyledText
              data-anchor-id={Tag.AlreadySignedUp}
              onClick={e => {
                e.preventDefault()
                secondaryAction()
              }}
            >
              {t.alreadySignedUp()}
            </BtnStyledText>
          </MediaQuery>
        </SlideFormContainer>
      </React.Fragment>
    )
  }
}

export default Slide
